module.exports = __webpack_public_path__ + "img/logivialogga_transp_min.66024668.png";